import register from 'preact-custom-element';
import GwpGiftModal from './GwpGiftModal';
register(GwpGiftModal, 'gwp-gift-modal');
